import React from 'react'

import { BudgetChartBudgets } from 'src/types'

import { useStepsContext } from 'src/views/Requests/views/Form'

import Budget from '..'
import { StyledCard } from './styles'

function BudgetCard() {
  const { budgetChart = [] as BudgetChartBudgets[] } = useStepsContext()

  return (
    <StyledCard title="common.budget.title">
      <Budget bars={budgetChart} />
    </StyledCard>
  )
}

export default BudgetCard
